/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postCwpList = (data) => makeApiCall(`/cwp/appointment/request`, 'POST', data);
export const postCwpDetails = (data) =>
  makeApiCall(`/cwp/appointment/request-detail`, 'POST', data);
export const postChangeStatus = (data) =>
  makeApiCall(`/cwp/appointment/request/update`, 'POST', data);
export const postRecoverStatus = (data) =>
  makeApiCall(`/cwp/appointment/request/recover`, 'POST', data);

export const postAppointmentList = (data) => makeApiCall(`/cwp/appointment/list`, 'POST', data);
export const postAppointmentDelete = (data) => makeApiCall(`/cwp/appointment/delete`, 'POST', data);
export const postAppointmentRecover = (data) =>
  makeApiCall(`/cwp/appointment/recover`, 'POST', data);

/* CWP APPROVAL APIS */

export const postCwpApprovalList = (data) =>
  makeApiCall(`/cwp/htar-appointment/request`, 'POST', data);

export const postCwpApprovalDetail = (data) =>
  makeApiCall(`/cwp/htar-appointment/request/detail`, 'POST', data);

export const postCwpApprovalCalendar = (data) =>
  makeApiCall(`/cwp/htar-appointment/request/calendar`, 'POST', data);

export const postApprovaltUpdateStatus = (data) =>
  makeApiCall(`/cwp/htar-appointment/request/update`, 'POST', data);

export const postMultipleAppointmentRequest = (data) =>
  makeApiCall(`/cwp/appointment/multipl/request-detail`, 'POST', data);

export const postAppointtRequestUpdate = (data) =>
  makeApiCall(`/cwp/appointment/request/update`, 'POST', data);

/* CNC CWP APPROVAL API */

export const postCncCwpList = (data) => makeApiCall(`/cwp/cnc-appointment/request`, 'POST', data);

export const postCncCwpApprovalCalendar = (data) =>
  makeApiCall(`/cwp/cnc-appointment/request/calendar`, 'POST', data);

export const postCncCwpApprovalDetail = (data) =>
  makeApiCall(`/cwp/cnc-appointment/request/detail`, 'POST', data);

export const postCncApprovaltUpdateStatus = (data) =>
  makeApiCall(`/cwp/cnc-appointment/request/update`, 'POST', data);
